import { useMemo } from 'react';
import { useSmartLinkContext } from '@atlaskit/link-provider';
export var useControlDataExportConfig = function useControlDataExportConfig() {
  var _useSmartLinkContext = useSmartLinkContext(),
    connections = _useSmartLinkContext.connections,
    product = _useSmartLinkContext.product,
    shouldControlDataExport = _useSmartLinkContext.shouldControlDataExport;
  return useMemo(function () {
    return {
      baseUrl: connections.client.baseUrlOverride,
      envKey: connections.client.envKey,
      product: product,
      shouldControlDataExport: shouldControlDataExport
    };
  }, [connections.client.baseUrlOverride, connections.client.envKey, product, shouldControlDataExport]);
};